import PropTypes from 'prop-types';
import { PiUser } from 'react-icons/pi';

import { cn } from '#/lib/utils';

const SIZE_CLASS = {
  sm: 'size-8',
  md: 'size-14',
  lg: 'size-16',
};

/**
 * 帳號頭像：有 URL 則顯示照片，否則灰底小人圖示。
 */
const AccountAvatar = ({ display, size = 'md', className }) => {
  const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.md;

  if (display?.avatarUrl) {
    return (
      <img
        src={display.avatarUrl}
        alt=""
        className={cn('rounded-full object-cover', sizeClass, className)}
      />
    );
  }

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full bg-gray-200 text-muted-foreground',
        sizeClass,
        className,
      )}
      aria-hidden
    >
      <PiUser className={size === 'sm' ? 'size-4' : 'size-6'} />
    </div>
  );
};

AccountAvatar.propTypes = {
  display: PropTypes.shape({
    avatarUrl: PropTypes.string,
    initials: PropTypes.string,
  }),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
};

export default AccountAvatar;
